import TextArea from "../../../../components/UI/form/TextArea";
import React from "react";
import Card from "../../../../components/UI/Card";

const OrderNotes = ({errors,register, getValues, setValue}) => {
  return (
    <TextArea
      label={"Customer Note"}
      name="buyer_note"
      errors={errors}
      disable={true}
      placeholder={getValues('buyer_note')}
      register={register}/>
  );
}

export default OrderNotes